import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames/bind';

import styles from './PublisherSelector.module.css';

import * as $auth from 'modules/auth';

const cls = classnames.bind(styles);

export const PublisherSelector = ({ className }) => {
  const dispatch = useDispatch();
  const user = useSelector($auth.getCurrentUser);
  const selectedPublisherID = useSelector($auth.getSelectedPublisherId);

  const uniquePublishers = [...new Set(user.publishers)];

  return (
    <select
      value={selectedPublisherID ?? ''}
      onChange={(event) => {
        dispatch($auth.selectPublisherId(event.target.value));
      }}
      className={cls('select', className)}
    >
      {uniquePublishers.map((publisherId) => (
        <option key={publisherId} value={publisherId}>
          {publisherId}
        </option>
      ))}
    </select>
  );
};
